var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import isEqual from 'lodash/isEqual';
import { createObjectsCache } from '../singleton';
import { ConfigsRepository, DashboardsRepository, DashboardTopicsRepository, DashletsRepository, LocationsRepository, MetricSetsRepository, MetricsRepository, PeriodsRepository, ResourcesRepository, TextDataRepository, UnitsRepository, DataSourcesRepository, CubesRepository, DimensionsRepository, VarsRepository, } from '../repositories/ds';
import { BaseEntitiesService } from './BaseEntitiesService';
import { memLock } from '../Retainable';
import { RtService } from '../RtService';
import { ResourcesRepository as ResourcesBlobRepository } from '@bi/sync';
//
//           
//
export class ConfigsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new ConfigsRepository(schemaName));
    }
    _dispose() {
        ConfigsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new ConfigsService(String(id)), '__configsServices');
    static createInstance = ConfigsService._cache.get;
}
//
//         
//
export class UnitsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new UnitsRepository(schemaName));
    }
    _dispose() {
        UnitsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new UnitsService(String(id)), '__unitsServices');
    static createInstance = UnitsService._cache.get;
}
//
//           
//
export class MetricsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new MetricsRepository(schemaName));
    }
    _dispose() {
        MetricsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new MetricsService(String(id)), '__metricsServices');
    static createInstance = MetricsService._cache.get;
}
//
//               
//
export class MetricSetsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new MetricSetsRepository(schemaName));
    }
    _dispose() {
        MetricSetsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new MetricSetsService(String(id)), '__metricSetsServices');
    static createInstance = MetricSetsService._cache.get;
}
//
//             
//
export class LocationsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new LocationsRepository(schemaName));
    }
    _dispose() {
        LocationsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new LocationsService(String(id)), '__locationServices');
    static createInstance = LocationsService._cache.get;
}
//
//           
//
export class PeriodsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new PeriodsRepository(schemaName));
    }
    _dispose() {
        PeriodsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new PeriodsService(String(id)), '__periodsServices');
    static createInstance = PeriodsService._cache.get;
}
//
//                    
//
export class DashboardTopicsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new DashboardTopicsRepository(schemaName));
    }
    _dispose() {
        DashboardTopicsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new DashboardTopicsService(String(id)), '__dashboardTopicsServices');
    static createInstance = DashboardTopicsService._cache.get;
}
//
//              
//
export class DashboardsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new DashboardsRepository(schemaName));
    }
    _dispose() {
        DashboardsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new DashboardsService(String(id)), '__dashboardsServices');
    static createInstance = DashboardsService._cache.get;
}
//
//            
//
export class DashletsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new DashletsRepository(schemaName));
    }
    _dispose() {
        DashletsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new DashletsService(String(id)), '__dashletsServices');
    static createInstance = DashletsService._cache.get;
}
//
//                         
//
//
//             
//
export class ResourcesService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new ResourcesRepository(schemaName));
    }
    /*                                                                         */
    batchUpdates(fn) {
        return this._freezeUpdates(fn);
    }
    async updateContentType(id, content_type) {
        const r = await this._repo.update(id, { content_type });
        this._updateInternalOneEntity(r);
        return r;
    }
    async updateAltId(id, alt_id) {
        const r = await this._repo.update(id, { alt_id });
        this._updateInternalOneEntity(r);
        return r;
    }
    async _uploadFile(id, file) {
        //                                                                          
        //                                                                         
        //                                                                        
        //                                                               
        //                                                                   
        //                                                                 
        const c = file.content ?? file;
        let payload;
        if (typeof c === 'string')
            payload = c;
        else if (c instanceof Uint8Array)
            payload = c;
        else if (c instanceof ArrayBuffer)
            payload = new Uint8Array(c);
        else if (typeof c?.arrayBuffer === 'function')
            payload = new Uint8Array(await c.arrayBuffer());
        else
            throw new Error('_uploadFile: payload must be string, Uint8Array, ArrayBuffer or Blob/File');
        await new ResourcesBlobRepository(this._schemaName).writeBlob({ id, alt_id: file.name, content_type: file.type }, payload);
    }
    async updateContent(id, file) {
        await this._uploadFile(id, file);
        const e = await this._reloadEntityWithId(id);
        this._updateInternalOneEntity(e);
        RtService.publishDsMessage(this._schemaName, 'UPDATE_' + this._tableName.toUpperCase(), e);
        return true;
    }
    async createContent(file) {
        const { name, type } = file;
        let e = await this._create({ alt_id: name, content_type: type }); //                     
        await this._uploadFile(e.id, file);
        e = await this._repo.getById(e.id); //                                            
        this._updateInternalOneEntity(e);
        RtService.publishDsMessage(this._schemaName, 'CREATE_' + this._tableName.toUpperCase(), e); //                       
        return e;
    }
    _isEntitiesEquals(newEntities, prevEntities) {
        return isEqual(newEntities, prevEntities);
    }
    _dispose() {
        ResourcesService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new ResourcesService(String(id)), '__resourcesServices');
    static createInstance = ResourcesService._cache.get;
}
__decorate([
    memLock
], ResourcesService.prototype, "updateContentType", null);
__decorate([
    memLock
], ResourcesService.prototype, "updateAltId", null);
__decorate([
    memLock
], ResourcesService.prototype, "updateContent", null);
__decorate([
    memLock
], ResourcesService.prototype, "createContent", null);
//
//             
//
export class TextDataService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new TextDataRepository(schemaName));
    }
    _dispose() {
        TextDataService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new TextDataService(String(id)), '__textDataServices');
    static createInstance = TextDataService._cache.get;
}
export class DataSourcesService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new DataSourcesRepository(schemaName));
    }
    _dispose() {
        DataSourcesService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(schemaName => new DataSourcesService(String(schemaName)), '__ds_DataSourcesService');
    static createInstance = DataSourcesService._cache.get;
}
export class CubesService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new CubesRepository(schemaName));
    }
    _dispose() {
        CubesService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new CubesService(String(id)), '__cubesServices');
    static createInstance = CubesService._cache.get;
}
export class DimensionsService extends BaseEntitiesService {
    source_ident;
    cube_name;
    constructor(schema_name, source_ident, cube_name) {
        super(new DimensionsRepository(schema_name, source_ident, cube_name));
        this.source_ident = source_ident;
        this.cube_name = cube_name;
    }
    _dispose() {
        DimensionsService._cache.remove(this._schemaName, this.source_ident, this.cube_name);
        super._dispose();
    }
    static _cache = createObjectsCache((schema_name, source_ident, cube_name) => new DimensionsService(schema_name, source_ident, cube_name), '__dimensionsServices');
    static createInstance = DimensionsService._cache.get;
}
//
//        
//
export class VarsService extends BaseEntitiesService {
    constructor(schemaName) {
        super(new VarsRepository(schemaName));
    }
    _dispose() {
        VarsService._cache.remove(this._schemaName);
        super._dispose();
    }
    static _cache = createObjectsCache(id => new VarsService(String(id)), '__varsServices');
    static createInstance = VarsService._cache.get;
}
